<template>
  <ServiceCard 
    title="AWS Cloud Architect & Developer"
    subtitle="Scalable, secure, and cost-effective solutions"
    description="Transform your infrastructure with expert AWS architecture, migration services, and cloud-native development."
    to="/services/aws-cloud-architect"
    gradient-start="#ff9500"
    gradient-end="#ff6b00"
    button-text="Learn More"
  />
  
</template>

<script setup>

</script>